export default "__VITE_ASSET__bb4a1d32__"